export default class Console {
  constructor() { }

  setConfig(config: any) {
    const { Debug } = config || {};
    // @ts-ignore
    this.debug = !!Debug;
  }

  _debug(type: any, ...params: any[]) {
    // @ts-ignore
    if (this.debug) {
      // @ts-ignore
      console[type](`[GReporter]`, ...params);
    }
  }

  log(...params: any[]) {
    this._debug("info", ...params);
  }

  warn(...params: any[]) {
    this._debug("warn", ...params);
  }
}
